import { render, staticRenderFns } from "./MessageSystemNote.vue?vue&type=template&id=22b50b60&scoped=true&"
import script from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
export * from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSystemNote.vue?vue&type=style&index=0&id=22b50b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b50b60",
  null
  
)

export default component.exports